import React from 'react';

interface IMotorCycleIconProps {
	size?: string;
	className?: string;
}

export const MotorCycleIcon = ({ size = '24', className }: IMotorCycleIconProps) => {
	return (
		<svg aria-hidden="true" width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
			<path
				d="M4.5 17.5C6.15685 17.5 7.5 16.1569 7.5 14.5C7.5 12.8431 6.15685 11.5 4.5 11.5C2.84315 11.5 1.5 12.8431 1.5 14.5C1.5 16.1569 2.84315 17.5 4.5 17.5Z"
				stroke="#3D3D3D"
				strokeLinejoin="round"
			/>
			<path
				d="M9.5 14.5C9.5 12.8642 8.71445 11.4118 7.5 10.4996M4.5 9.5C3.37439 9.5 2.33566 9.87194 1.5 10.4996"
				stroke="#3D3D3D"
				strokeLinejoin="round"
			/>
			<path d="M13.5 12.5H12.5" stroke="#3D3D3D" strokeLinecap="square" strokeLinejoin="round" />
			<path
				d="M14.7443 7.50319C12.7826 7.41422 10.8113 9.21317 10.5 9.51047L10.7248 10.5C10.7248 10.5 14.8442 10.4783 15.7203 10.4783C16.5965 10.4783 16.4966 9.60161 16.4966 9.60161V8.18458C16.0566 7.81784 15.4821 7.53574 14.7443 7.50319Z"
				fill="white"
				stroke="#3D3D3D"
				strokeMiterlimit="10"
				strokeLinejoin="round"
			/>
			<path d="M4.5 14.5H15L16.5 10.5V8.5" stroke="#3D3D3D" strokeLinecap="square" />
			<path
				d="M4.5 8.5H9C9.82843 8.5 10.5 9.17157 10.5 10V10.5H6C5.17157 10.5 4.5 9.82843 4.5 9V8.5Z"
				stroke="#3D3D3D"
			/>
			<path
				d="M19.5 17.5C21.1569 17.5 22.5 16.1569 22.5 14.5C22.5 12.8431 21.1569 11.5 19.5 11.5C17.8431 11.5 16.5 12.8431 16.5 14.5C16.5 16.1569 17.8431 17.5 19.5 17.5Z"
				stroke="#3D3D3D"
				strokeLinejoin="round"
			/>
			<path d="M19.5 14.5L16.0967 5.5H14" stroke="#3D3D3D" strokeLinecap="square" strokeLinejoin="round" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.7285 8.87347L18.6134 9.40987C18.9823 9.63388 19.5 9.41444 19.5 9.03652V7.96373C19.5 7.58429 18.9823 7.36638 18.6134 7.59039L17.7285 8.12678C17.4238 8.31117 17.4238 8.68909 17.7285 8.87347Z"
				stroke="#3D3D3D"
				strokeMiterlimit="10"
			/>
		</svg>
	);
};
